import { useAppSelector } from 'app/hooks';
import Button from 'blocks/Button';
import Input from 'blocks/Input';
import Breadcrumb from 'components/Breadcrumb';
import TermsCondition from 'components/TermsCondition';
import TransferMilageModal from 'components/modals/TransferMilesModal';
import Paths from 'helper/paths';
import { buyMilageTerms } from 'helper/static-constant';
import { useForm } from 'hooks/useForm';
import WithSidebar from 'layouts/WithSidebar';
import BreadcrumbInterface from 'models/breadcrumb/breadcrumb.interface';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { UserTierState } from 'store/tiers/tiersSlice';
import * as S from './transfer.styles';

const TransferMilage = () => {
  const { t } = useTranslation();
  const userTiers = useAppSelector(UserTierState);
  const breadcrumbLinks = [
    {
      title: t(`pageTitles.${Paths.Dashboard.index().name}`),
      url: Paths.Dashboard.index().route,
      active: true,
    },
    {
      title: t(`pageTitles.${Paths.Services.transfer().name}`),
      url: '',
      active: false,
    },
  ] as BreadcrumbInterface[];

  const transferMilageModal = useRef<any>();
  // const transferMilageReceiptModal = useRef<any>()

  const { inputFields, handleChange } = useForm({
    miles: {
      name: 'miles',
      value: '',
      type: 'number',
      placeholder: t('pages.services.transferMilage.sections.form.sections.milesToTransfer.fields.amount.placeholder'),
      label: t('pages.services.transferMilage.sections.form.sections.milesToTransfer.fields.amount.label'),
    },
    membershipNumber: {
      name: 'membershipNumber',
      value: '',
      type: 'text',
      label: t('pages.services.transferMilage.sections.form.sections.memberInformation.fields.membershipNumber.label'),
      placeholder: t(
        'pages.services.transferMilage.sections.form.sections.memberInformation.fields.membershipNumber.placeholder'
      ),
    },
    email: {
      name: 'email',
      value: '',
      type: 'text',
      label: t('pages.services.transferMilage.sections.form.sections.memberInformation.fields.email.label'),
      placeholder: t('pages.services.transferMilage.sections.form.sections.memberInformation.fields.email.placeholder'),
    },
  });

  return (
    <WithSidebar>
      <S.TransferMilage>
        <Breadcrumb links={breadcrumbLinks} title={t('pages.services.transferMilage.title')} />

        <S.TransferMilageBox>
          <S.TransferMilageBoxLeft>
            <S.TransferMilageBoxLeftCard>
              <S.TransferMilageBoxLeftText>
                {t('pages.services.transferMilage.sections.form.sections.milesToTransfer.title')}
              </S.TransferMilageBoxLeftText>
              <Input inputField={inputFields.miles} dir={'ltr'} onChange={handleChange} />
            </S.TransferMilageBoxLeftCard>

            <S.TransferMilageBoxLeftMember>
              <S.TransferMilageBoxLeftText>
                {t('pages.services.transferMilage.sections.form.sections.memberInformation.title')}
              </S.TransferMilageBoxLeftText>
              <Input inputField={inputFields.membershipNumber} dir={'ltr'} onChange={handleChange} />

              {/* <S.TransferMilageBoxLeftMemberDivider>
                <S.TransferMilageBoxLeftMemberDividerSpan>
                  {t('pages.services.transferMilage.sections.form.sections.memberInformation.divider')}
                </S.TransferMilageBoxLeftMemberDividerSpan>
              </S.TransferMilageBoxLeftMemberDivider>
              <Input inputField={inputFields.email} onChange={handleChange} /> */}

              <Button
                styleType="default"
                className="transfer-button mx-auto fs-xs mt-auto"
                onClick={() => {
                  if (Number(inputFields.miles.value) > (userTiers?.rewardMilage || 0))
                    return toast.error(t('pages.services.convertMilage.sections.form.sections.milesToConvert.error'));
                  transferMilageModal.current.openModal();
                }}
              >
                {t('pages.services.transferMilage.sections.form.submitCTA')}
              </Button>
            </S.TransferMilageBoxLeftMember>
          </S.TransferMilageBoxLeft>

          <S.TransferMilageBoxRight>
            <TermsCondition
              title={t('pages.services.transferMilage.sections.terms.title')}
              termsItem={buyMilageTerms}
            />
          </S.TransferMilageBoxRight>
        </S.TransferMilageBox>
      </S.TransferMilage>

      <TransferMilageModal
        ref={transferMilageModal}
        email={inputFields.email.value}
        membershipNumber={inputFields.membershipNumber.value}
        miles={inputFields.miles.value}
      />
      {/* <TransferMilageReceiptModal ref={transferMilageReceiptModal} /> */}
    </WithSidebar>
  );
};

export default TransferMilage;
